import { ShiftDto } from './shift-dto.model';


export class ShiftDayDto implements IShiftDayDto {
    id!: number | undefined;
    dayName!: string | undefined;
    shift!: ShiftDto;

    constructor(data?: IShiftDayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dayName = _data["dayName"];
            this.shift = _data["shift"] ? ShiftDto.fromJS(_data["shift"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ShiftDayDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftDayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dayName"] = this.dayName;
        data["shift"] = this.shift ? this.shift.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IShiftDayDto {
    id: number | undefined;
    dayName: string | undefined;
    shift: ShiftDto;
}

